export const DMS_MODULE = 'Servis';
export const NAME = 'TimeClocking';
export const API_NAME = 'TimeClocking';
export const EXPORT_FILE_NAME='TimeClocking.xlsx';
export const CRUMB_LABEL_KEY = 'TimeClocking';
